import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import PlantillaScreenRemastered from "../CRM/PlantillaScreenRemastered";
import MenuModulo from "../components/MenuModulo/MenuModulo";
import { LoaderScreen } from "../components/LoaderScreen";
import { GRUPOS_MENU_CREDITO } from "../../Arrays/MenuCreditoArray";
import { registrarAccesoReciente } from "../../Helpers/AccesosRecientes";
import { navegarAcceso } from "../../Helpers/NavegarAcceso";
import request from "../../Helpers/API";

/**
 * CreditoMenuScreen — menú principal del módulo de Crédito (rediseño).
 *
 * Sustituye a CreditoMainScreen (lista de botones en dos columnas). Consume el MISMO endpoint y
 * los mismos permisos; lo único que cambia es la presentación: los accesos se agrupan en tarjetas
 * y se pueden buscar. La agrupación vive en src/Arrays/MenuCreditoArray.js.
 *
 * Al ser la pantalla principal del módulo no lleva botón "Regresar" (mostrarRegresar={false}) ni
 * acciones de filtro, agregar o excel.
 *
 * El componente anterior sigue en el proyecto: para revertir basta con cambiar la línea del Route
 * en ListadoCredito.js.
 *
 * Creado: 2026-09-17 — IA (Claude)
 */

const ID_MODULO_CREDITO = 9;

const CreditoMenuScreen = () => {
  const history = useHistory();
  const [accesos, setAccesos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });

  useEffect(() => {
    setCargando(true);
    setLoader((previo) => ({ ...previo, mostrar: true }));

    request
      .get(`MenuUsuarios/AccesosMenus?idmodulo=${ID_MODULO_CREDITO}`)
      .then((result) => {
        // El API ya regresa los accesos filtrados por los permisos del usuario.
        const listado = Array.isArray(result)
          ? result.map((item) => ({ titulo: item.titulo, ruta: item.ruta }))
          : [];

        // Se conserva la limpieza que hacía el menú anterior al entrar al módulo.
        try {
          localStorage.removeItem("filtroEstado");
        } catch (error) {
          // Sin acción: el filtro guardado es opcional.
        }

        setAccesos(listado);
        setCargando(false);
        setLoader((previo) => ({ ...previo, mostrar: false }));
      })
      .catch((error) => {
        setAccesos([]);
        setCargando(false);
        setLoader((previo) => ({ ...previo, mostrar: false }));
        Swal.fire("MENÚ DE CRÉDITO", JSON.stringify(error), "error");
      });
  }, []);

  const onAbrir = (acceso) => {
    if (!acceso || typeof acceso.ruta !== "string") return;

    registrarAccesoReciente(ID_MODULO_CREDITO, acceso);
    navegarAcceso(history, acceso.ruta);
  };

  return (
    <PlantillaScreenRemastered titulo="Crédito" mostrarRegresar={false} className="menu-modulo-screen">
      <LoaderScreen loader={loader} />
      <MenuModulo
        accesos={accesos}
        grupos={GRUPOS_MENU_CREDITO}
        idmodulo={ID_MODULO_CREDITO}
        onAbrir={onAbrir}
        cargando={cargando}
        placeholderBusqueda="Buscar acceso: escribe pagaré, buró, cartera, tasa…"
      />
    </PlantillaScreenRemastered>
  );
};

export default CreditoMenuScreen;
